// extracted by mini-css-extract-plugin
export default {"detail":"detail---W3xpi","section":"section---N2JSW"};